import { DefaultCellHeader, DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { DefaultCell, DefaultCellRightAlign } from "app/components/React/Table/cells";
import { ItemsButtonCell } from "app/components/React/Table/cells/ItemsButtonCell/ItemsButtonCell";
import { translate } from "app/filters/i18nFilter";
import type { FlexTableColumnType } from "app/pages/sales-intelligence/types";
import {
    CATEGORY_FIELD_NAME,
    DEFAULT_SORT_DIRECTION,
    DOMAINS_COUNT_FIELD_NAME,
    TOPIC_FIELD_NAME,
} from "../types/constants";
import withCellComponentIntentAction from "../hoc/withCellComponentIntentAction";

type SortDirection = "asc" | "desc";
type OrderByColumn = "name" | "category" | "domainsCount";

type IntentColumnType = FlexTableColumnType & {
    showTotalCount?: boolean;
    disableHeaderCellHover?: boolean;
    lastColumnFixed?: boolean;
    maxWidth?: number;
    isResizable?: boolean;
};

const intentTableColumns: IntentColumnType[] = [
    {
        field: TOPIC_FIELD_NAME,
        get displayName() {
            return translate("si.intent.management.add-topic.columns.topics");
        },
        cellComponent: DefaultCell,
        format: "string",
        type: "string",
        sortable: true,
        isSorted: false,
        headerComponent: DefaultCellHeader,
        sortDirection: "desc",
        showTotalCount: true,
        visible: true,
        isResizable: true,
    },
    {
        field: CATEGORY_FIELD_NAME,
        get displayName() {
            return translate("si.intent.management.add-topic.columns.category");
        },
        type: "string",
        cellComponent: DefaultCell,
        format: "string",
        sortable: true,
        isSorted: false,
        headerComponent: DefaultCellHeader,
        sortDirection: "desc",
        visible: true,
        isResizable: true,
    },
    {
        field: DOMAINS_COUNT_FIELD_NAME,
        get displayName() {
            return translate("si.intent.management.add-topic.columns.domain-counts");
        },
        cellComponent: DefaultCellRightAlign,
        type: "double",
        format: "number",
        sortable: true,
        isSorted: false,
        headerComponent: DefaultCellHeaderRightAlign,
        sortDirection: "desc",
        visible: true,
    },
    {
        field: "",
        type: "string",
        format: "string",
        cellClass: "intent-custom-cell",
        headerComponent: DefaultCellHeader,
        cellComponent: withCellComponentIntentAction(ItemsButtonCell),
        disableHeaderCellHover: true,
        sortable: false,
        visible: true,
        lastColumnFixed: true,
        maxWidth: 109,
    },
];

export const getMappingForSorting = (field: string): string => {
    switch (field) {
        case TOPIC_FIELD_NAME:
            return "topic";
        case DOMAINS_COUNT_FIELD_NAME:
            return "domains_count";
        default:
            return field;
    }
};

export const getMappingSortingFieldForUi = (field: string): OrderByColumn => {
    switch (field) {
        case "topic":
            return TOPIC_FIELD_NAME;
        case "domains_count":
            return DOMAINS_COUNT_FIELD_NAME;
        default:
            return field as OrderByColumn;
    }
};

export const intentTableColumnsConfigGen = (sortByField: OrderByColumn, sortDirection: SortDirection) => {
    return intentTableColumns.map((col) => {
        if (!col.sortable) {
            return col;
        }
        const isSorted = sortByField && col.field === sortByField;
        return {
            ...col,
            isSorted,
            sortDirection: isSorted ? sortDirection : DEFAULT_SORT_DIRECTION,
        };
    });
};
